"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
require("./Button.css");
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("..");
function Button(_a) {
    var children = _a.children, ariaLabel = _a.ariaLabel, badge = _a.badge, Icon = _a.icon, _b = _a.iconPosition, iconPosition = _b === void 0 ? "start" : _b, _c = _a.appearance, appearance = _c === void 0 ? "default" : _c, onClick = _a.onClick, onBlur = _a.onBlur, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.iconSize, iconSize = _e === void 0 ? "small" : _e, spinner = _a.spinner, _f = _a.type, type = _f === void 0 ? "button" : _f;
    var buttonClass = (0, classnames_1.default)("nimbus--button", "nimbus--button--".concat(appearance), { "nimbus--button-loading": spinner });
    var iconSpinner = spinner && React.createElement(__1.Spinner, null);
    var iconStart = !spinner && Icon && iconPosition === "start" && (React.createElement(Icon, { size: iconSize }));
    var iconEnd = !spinner && Icon && iconPosition === "end" && (React.createElement(Icon, { size: iconSize }));
    var buttonBadge = badge && (React.createElement(__1.Badge, { appearance: appearance === "transparent" ? "default" : appearance, label: badge }));
    var handleClick = function (e) {
        e.stopPropagation();
        if (typeof onClick === "function") {
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
        }
    };
    var handleBlur = function (e) {
        e.stopPropagation();
        if (typeof onClick === "function") {
            onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
        }
    };
    return (React.createElement("button", { "aria-label": ariaLabel, type: type, className: buttonClass, onClick: handleClick, onBlur: handleBlur, disabled: disabled },
        iconSpinner,
        iconStart,
        children,
        buttonBadge,
        iconEnd));
}
var Skeleton = function () { return React.createElement("div", { className: "nimbus--button-skeleton" }); };
Button.Skeleton = Skeleton;
exports.default = Button;
//# sourceMappingURL=index.js.map